<template>
    <div :class="`splitwrap size_${$mq}`">
        <mq-layout :mq="['sm', 'md', 'lg']">
            <b-sidebar v-model="myShowSidebar" :aria-expanded="myShowSidebar" shadow
                    :title="sidebarTitle" class="mainsidebar" id="mainsidebar"
                    @change="$emit('showSidebar', $event)">
                <router-view name="folders"></router-view>
            </b-sidebar>
        </mq-layout>
        <mq-layout mq="hg">
            <aside id="foldertreewrap">
                <router-view name="folders"></router-view>
            </aside>
        </mq-layout>
        <article id="messagelistwrap">
            <keep-alive include="messageList">
                <router-view name="rightpane"
                        v-if="$store.state.settingsLoaded && $store.state.foldersLoaded"></router-view>
            </keep-alive>
        </article>
    </div>
</template>

<script>
export default {
  name: 'splitView',
  data: function() {
    return {
      myShowSidebar: false
    };
  },
  props: {
    showSidebar: Boolean
  },
  watch: {
    showSidebar(newVal) {
      this.myShowSidebar = newVal;
      console.log('route', this.$route);
    }
  },
  computed: {
    sidebarTitle() {
      const r = this.$route.matched.find(r => r.meta.sidebarName);
      if (r) {
        return this.$t(`sidebar.${r.meta.sidebarName}`);
      } else {
        return '';
      }
    }
  }

};
</script>

<style scoped lang="scss">
    .splitwrap {
        display: grid;
        grid-template-columns: 300px 1fr;
        grid-template-rows: calc(100vh - 40px);
        grid-template-areas: "folders messages";
        height: 100%;
        &.size_sm, &.size_md, &.size_lg {
            grid-template-columns: 0 1fr;
        }
    }

    #foldertreewrap {
        grid-area: folders;
        overflow: hidden;
        height: 100%;
    }

    #messagelistwrap {
        grid-area: messages;
    }

</style>
